const additionalFields = [
  { headerName: "Carrier", field: "carrier", sortable: true },
  { headerName: "Department", field: "department", sortable: true },
  { headerName: "Pro-Rata Date", field: "proRataDate", sortable: true },
];
const voipServicesHeaders = [
  { headerName: "UBCustNo**", field: "ubCustNo", sortable: true },
  { headerName: "Csn", field: "csn", sortable: true },
  { headerName: "UBPLANID**", field: "ubplanid", sortable: true },
  { headerName: "Name", field: "name", sortable: true },
  { headerName: "MarketSegment**", field: "marketSegment", sortable: true },
  { headerName: "StreetNumber", field: "streetNumber", sortable: true },
  { headerName: "StreetName", field: "streetName", sortable: true },
  { headerName: "StreetType", field: "streetType", sortable: true },
  { headerName: "Suburb", field: "suburb", sortable: true },
  { headerName: "State", field: "state", sortable: true },
  { headerName: "Postcode", field: "postcode", sortable: true },
  { headerName: "PlanStartDate**", field: "planStartDate", sortable: true },
  { headerName: "ContractLength", field: "contractLength", sortable: true },
  ...additionalFields,
  { headerName: "Success", field: "success", sortable: true },
  {
    headerName: "Reason",
    field: "reason",
    minWidth: 300,
    width: 300,
    sortable: true,
  },
];
// for example data
const voipServicesExampleHeader = [
  { headerName: "UBCustNo*", field: "ubCustNo*", sortable: true },
  { headerName: "Csn", field: "csn", sortable: true },
  { headerName: "UBPLANID*", field: "ubplanid*", sortable: true },
  { headerName: "Name", field: "name", sortable: true },
  { headerName: "MarketSegment*", field: "marketSegment*", sortable: true },
  { headerName: "StreetNumber", field: "streetNumber", sortable: true },
  { headerName: "StreetName", field: "streetName", sortable: true },
  { headerName: "StreetType", field: "streetType", sortable: true },
  { headerName: "Suburb", field: "suburb", sortable: true },
  { headerName: "State", field: "state", sortable: true },
  { headerName: "Postcode", field: "postcode", sortable: true },
  { headerName: "PlanStartDate*", field: "planStartDate*", sortable: true },
  { headerName: "ContractLength", field: "contractLength", sortable: true },
  ...additionalFields,
  { headerName: "Success", field: "success", sortable: true },
  {
    headerName: "Reason",
    field: "reason",
    minWidth: 300,
    width: 300,
    sortable: true,
  },
];

const transactionsHeaders = [
  { headerName: "UBCustNo**", field: "ubCustNo", sortable: true },
  { headerName: "Csn", field: "csn", sortable: true },
  { headerName: "Description", field: "description", sortable: true },
  { headerName: "Charge", field: "charge", sortable: true },
  { headerName: "ChargeDate", field: "chargeDate", sortable: true },
  { headerName: "Success", field: "success", sortable: true },
  { headerName: "Reason", field: "reason", sortable: true },
];
const newMobilesHeaders = [
  { headerName: "UBCustNo**", field: "ubCustNo", sortable: true },
  { headerName: "Csn**", field: "csn", sortable: true },
  { headerName: "UBPLANID**", field: "ubplanid", sortable: true },
  { headerName: "Name", field: "name", sortable: true },
  { headerName: "MarketSegment**", field: "marketSegment", sortable: true },
  { headerName: "StreetNumber**", field: "streetNumber", sortable: true },
  { headerName: "StreetName", field: "streetName", sortable: true },
  { headerName: "StreetType", field: "streetType", sortable: true },
  { headerName: "Suburb", field: "suburb", sortable: true },
  { headerName: "State**", field: "state", sortable: true },
  { headerName: "Postcode", field: "postcode", sortable: true },
  { headerName: "PlanStartDate**", field: "planStartDate", sortable: true },
  { headerName: "ContractLength", field: "contractLength", sortable: true },
  {
    headerName: "Service Type (3G/4G/5G)",
    field: "networkType",
    sortable: true,
  },
  { headerName: "Carrier*", field: "carrier", sortable: true },
  { headerName: "Department", field: "department", sortable: true },
  { headerName: "Pro-Rata Date", field: "proRataDate", sortable: true },
  { headerName: "Success", field: "success", sortable: true },
  { headerName: "Reason", field: "reason", sortable: true },
];

// for example data
const newMobilesExampleHeaders = [
  { headerName: "UBCustNo*", field: "ubCustNo*", sortable: true },
  { headerName: "Csn*", field: "csn*", sortable: true },
  { headerName: "UBPLANID*", field: "ubplanid*", sortable: true },
  { headerName: "Name", field: "name", sortable: true },
  { headerName: "MarketSegment*", field: "marketSegment*", sortable: true },
  { headerName: "StreetNumber*", field: "streetNumber*", sortable: true },
  { headerName: "StreetName", field: "streetName", sortable: true },
  { headerName: "StreetType", field: "streetType", sortable: true },
  { headerName: "Suburb", field: "suburb", sortable: true },
  { headerName: "State*", field: "state*", sortable: true },
  { headerName: "Postcode", field: "postcode", sortable: true },
  { headerName: "PlanStartDate*", field: "planStartDate*", sortable: true },
  { headerName: "ContractLength", field: "contractLength", sortable: true },
  {
    headerName: "Service Type (3G/4G/5G)",
    field: "networkType",
    sortable: true,
  },
  { headerName: "Carrier*", field: "carrier*", sortable: true },
  { headerName: "Department", field: "department", sortable: true },
  { headerName: "Pro-Rata Date", field: "proRataDate", sortable: true },
  { headerName: "Success", field: "success", sortable: true },
  { headerName: "Reason", field: "reason", sortable: true },
];

const disconnectHeaders = [
  { headerName: "UBCustNo**", field: "ubCustNo", sortable: true },
  { headerName: "Csn", field: "csn", sortable: true },
  { headerName: "EndDate", field: "endDate", sortable: true },
  { headerName: "Success", field: "success", sortable: true },
  { headerName: "Reason", field: "reason", sortable: true },
];

const nbnHeaders = [
  { headerName: "UBCustNo*", field: "ubCustNo", sortable: true },
  { headerName: "Street Number", field: "streetNumber", sortable: true },
  { headerName: "Service_Street", field: "service_Street", sortable: true },
  { headerName: "Service_Street2", field: "service_Street2", sortable: true },
  { headerName: "Service_City", field: "service_City", sortable: true },
  { headerName: "Service_State*", field: "service_State", sortable: true },
  { headerName: "Service_Postcode", field: "service_Postcode", sortable: true },
  { headerName: "ServiceNumber*", field: "serviceNumber", sortable: true },
  { headerName: "nbn_service_type", field: "nbn_service_type", sortable: true },
  { headerName: "UserName", field: "userName", sortable: true },
  { headerName: "Password", field: "password", sortable: true },
  { headerName: "UBPlan*", field: "ubPlan", sortable: true },
  { headerName: "Contract_Term", field: "contract_Term", sortable: true },
  { headerName: "ContractStart*", field: "contractStart", sortable: true },
  { headerName: "LocId*", field: "locId", sortable: true },
  { headerName: "FixedIP", field: "fixedIP", sortable: true },
  { headerName: "SC", field: "sc", sortable: true },
  { headerName: "CPI", field: "cpi", sortable: true },
  { headerName: "UniD*", field: "uniD", sortable: true },
  ...additionalFields,
  { headerName: "Success", field: "success", sortable: true },
  {
    headerName: "Reason",
    field: "reason",
    minWidth: 300,
    width: 300,
    sortable: true,
  },
];
// for example data
const nbnExampleHeaders = [
  { headerName: "UBCustNo*", field: "ubCustNo*", sortable: true },
  { headerName: "Street Number", field: "streetNumber", sortable: true },
  { headerName: "Service_Street", field: "service_Street", sortable: true },
  { headerName: "Service_Street2", field: "service_Street2", sortable: true },
  { headerName: "Service_City", field: "service_City", sortable: true },
  { headerName: "Service_State**", field: "service_State*", sortable: true },
  { headerName: "Service_Postcode", field: "service_Postcode", sortable: true },
  { headerName: "ServiceNumber**", field: "serviceNumber*", sortable: true },
  { headerName: "nbn_service_type", field: "nbn_service_type", sortable: true },
  { headerName: "UserName", field: "userName", sortable: true },
  { headerName: "Password", field: "password", sortable: true },
  { headerName: "UBPlan**", field: "ubPlan*", sortable: true },
  { headerName: "Contract_Term", field: "contract_Term", sortable: true },
  { headerName: "ContractStart**", field: "contractStart*", sortable: true },
  { headerName: "LocId**", field: "locId*", sortable: true },
  { headerName: "FixedIP", field: "fixedIP", sortable: true },
  { headerName: "SC", field: "sc", sortable: true },
  { headerName: "CPI", field: "cpi", sortable: true },
  { headerName: "UniD", field: "uniD", sortable: true },
  ...additionalFields,
  { headerName: "Success", field: "success", sortable: true },
  {
    headerName: "Reason",
    field: "reason",
    minWidth: 300,
    width: 300,
    sortable: true,
  },
];

const mnfHeaders = [
  {
    headerName: "RegisteredCompanyName",
    field: "registeredCompanyName",
    sortable: true,
  },
  { headerName: "Abn", field: "abn", sortable: true },
  { headerName: "Address", field: "address", sortable: true },
  { headerName: "DirectorsName", field: "directorsName", sortable: true },
  { headerName: "Email", field: "email", sortable: true },
  { headerName: "BankAccountName", field: "bankAccountName", sortable: true },
  { headerName: "Bsb", field: "bsb", sortable: true },
  { headerName: "BankAccountNo", field: "bankAccountNo", sortable: true },
  { headerName: "DealerManagerId", field: "dealerManagerId", sortable: true },
  { headerName: "Success", field: "success", sortable: true },
  { headerName: "Reason", field: "reason", sortable: true },
];

const customerHeaders = [
  {
    headerName: "Company Name*",
    field: "companyName",
    minWidth: 90,
    sortable: true,
  },
  { headerName: "ABN", field: "abn", minWidth: 90, sortable: true },
  { headerName: "ACN", field: "acn", minWidth: 90, sortable: true },
  {
    headerName: "Customer Type (Business/Residential)*",
    field: "customerType",
    minWidth: 90,
    sortable: true,
  },
  { headerName: "Address*", field: "address", sortable: true },
  {
    headerName: "Salutation*",
    field: "salutation",
    minWidth: 70,
    sortable: true,
  },
  {
    headerName: "Contact First Name*",
    field: "contactFirstName",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Contact Last Name*",
    field: "contactLastName",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Contact Phone*",
    field: "contactPhone",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Contact Mobile*",
    field: "contactMobile",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Contact Email*",
    field: "contactEmail",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Billing Email",
    field: "billingEmail",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Alternate Customer ID*",
    field: "alternateCustomerID",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Hosted PBX Domain",

    field: "hostedPbxDomain",

    minWidth: 90,

    sortable: true,
  },
  {
    headerName: "UBDealerId*",

    field: "uBDealerId",

    minWidth: 90,

    sortable: true,
  },
  { headerName: "GroupNo*", field: "groupNo", minWidth: 90, sortable: true },
  {
    headerName: "Bill Cycle Number*",

    field: "billCycleNumber",

    minWidth: 90,

    sortable: true,
  },
  {
    headerName: "Internet Access",
    field: "internetAccess",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Password",
    field: "password",
    minWidth: 90,
    sortable: true,
  },
  { headerName: "Success", field: "success", sortable: true },
  {
    headerName: "Reason",
    field: "reason",
    minWidth: 300,
    width: 300,
    sortable: true,
  },
];

const customerExampleHeader = [
  {
    headerName: "Company Name*",
    field: "companyName*",
    minWidth: 90,
    sortable: true,
  },
  { headerName: "ABN", field: "abn", minWidth: 90, sortable: true },
  { headerName: "ACN", field: "acn", minWidth: 90, sortable: true },
  {
    headerName: "Customer Type (Business/Residential)*",
    field: "customerType*",
    minWidth: 90,
    sortable: true,
  },
  { headerName: "Address*", field: "address*", sortable: true },
  {
    headerName: "Salutation*",
    field: "salutation*",
    minWidth: 70,
    sortable: true,
  },
  {
    headerName: "Contact First Name*",
    field: "contactFirstName*",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Contact Last Name*",
    field: "contactLastName*",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Contact Phone*",
    field: "contactPhone*",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Contact Mobile*",
    field: "contactMobile*",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Contact Email*",
    field: "contactEmail*",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Billing Email",
    field: "billingEmail",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Alternate Customer ID*",
    field: "alternateCustomerID*",
    minWidth: 90,
    sortable: true,
  },
  {
    headerName: "Hosted PBX Domain",

    field: "hostedPbxDomain",

    minWidth: 90,

    sortable: true,
  },
  {
    headerName: "UBDealerId*",

    field: "uBDealerId*",

    minWidth: 90,

    sortable: true,
  },
  { headerName: "GroupNo*", field: "groupNo*", minWidth: 90, sortable: true },
  {
    headerName: "Bill Cycle Number*",

    field: "billCycleNumber*",

    minWidth: 90,

    sortable: true,
  },
  { headerName: "Success", field: "success", sortable: true },
  {
    headerName: "Reason",
    field: "reason",
    minWidth: 300,
    width: 300,
    sortable: true,
  },
];

const inboundHeaders = [
  { headerName: "UBCustNo*", field: "ubCustNo" },
  { headerName: "ServiceNumber*", field: "csn" },
  { headerName: "UBPLANID*", field: "ubplanid" },
  { headerName: "Name*", field: "name" },
  // { headerName: "Address", field: "address" },
  { headerName: "PlanStartDate*", field: "planStartDate", sortable: true },
  { headerName: "ContractLength", field: "contractLength", sortable: true },
  { headerName: "Carrier*", field: "carrier", sortable: true },
  { headerName: "Department", field: "department", sortable: true },
  { headerName: "ProRataDate", field: "proRataDate", sortable: true },
  { headerName: "Success", field: "success" },
  { headerName: "Reason", field: "reason" },
];

const recurringChargesHeaders = [
  { headerName: "Customer Number*", field: "custNo" },
  { headerName: "ServiceNumber*", field: "serviceNo" },
  { headerName: "Amount*", field: "amountRecurring" },
  { headerName: "Description", field: "description" },
  { headerName: "Start Date*", field: "startDate", sortable: true },
  { headerName: "End Date", field: "endDate", sortable: true },
  { headerName: "Success", field: "success" },
  { headerName: "Reason", field: "reason" },
];

export {
  voipServicesHeaders,
  voipServicesExampleHeader,
  transactionsHeaders,
  newMobilesHeaders,
  newMobilesExampleHeaders,
  disconnectHeaders,
  nbnHeaders,
  nbnExampleHeaders,
  mnfHeaders,
  customerHeaders,
  customerExampleHeader,
  inboundHeaders,
  recurringChargesHeaders
};
